import React from 'react';
import { SvgIcon } from '@material-ui/core';

const ChevronRightIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 18 33" {...props}>
      <path d="M0.93934 32.3107C0.353553 31.7249 0.353553 30.7751 0.93934 30.1893L14.3787 16.75L0.93934 3.31066C0.353554 2.72487 0.353554 1.77513 0.93934 1.18934C1.52513 0.603554 2.47487 0.603554 3.06066 1.18934L17.5607 15.6893C18.1464 16.2751 18.1464 17.2249 17.5607 17.8107L3.06066 32.3107C2.47487 32.8964 1.52513 32.8964 0.93934 32.3107Z" />
    </SvgIcon>
  );
};

export default ChevronRightIcon;
